import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useConfig } from '../../DataStore/ConfigContext';
import RenderSecure from '../../util/RenderSecure';

const StarterPanel = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const {schoolProfile, getSchoolProfile} = useConfig();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(()=>{
    getSchoolProfile();
  }, []);

  const formatDateTime = (date) => {
    const options = {
      weekday: 'short', year: 'numeric', month: 'short', day: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: true,
    };
    return date.toLocaleString('en-US', options);
  };

  
  return (
    <div className="col-lg-4 mb-4 pr-4">
      <h1 className="display-5 mb-1">
        Manage your <span className="text-success">School</span> better.
      </h1>
      <p className="lead mb-0">{schoolProfile?.school_name}</p>
      <p className="text-muted">{formatDateTime(currentTime)}</p>

      <RenderSecure code ="NEW_STUDENT">
        <Link to="/student-new"
          className="btn btn-success btn-block mb-2"
        >
          <i className="fa fa-user-plus mr-2"></i> Register Student
        </Link>
      </RenderSecure>

      <RenderSecure code ="ENTER_MARKS">
        <Link to="/academics-marks-entry"
          className="btn btn-outline-primary btn-block"
        >
          <i className="fa fa-book"></i> Enter Exam Marks
        </Link>
      </RenderSecure>
    </div>
  );
};

export default StarterPanel;
